import { convertDimensionFromNameToId, isDimensionName, removeDatapointRequest, removeManyDatapointRequests, updateOrAddDatapointRequest } from "../../helpers";
import { DatapointKind } from "../../types";
import { getDatapointRequestElementFromColumnOptionState, getIdDimensionDatapointName } from "../../utils";
import { WidgetType } from "components/modal/widget-workshop/types";
import { formatToColumnTypes } from "components/widgets/grid/grid-column-types";
import { CommmonFormatEnum } from "datapoints";
import { language } from "language/default";
import { DisplayValueType, WidgetMode } from "store/current-dashboard/types";
import { WorkShopInitialStateByType, defaultComparisonMeasureName } from "store/widget-workshop/initialState";
export const getPercentOfTotalDatapointName = (id) => `P${id}`;
const supportsPercent = (option) => !option.metadata?.needsPublicIndex;
const isRawPercentMeasure = (option) => option.type === "insPercentageColumn";
const getMethod = (method, visitor) => visitor?.find((d) => d.method === method);
const getReducers = (pipelineParameter) => {
    const { compositeObjectBuilder: builder, nodesVisitorsReducer: nodes, customVisitorsReducer: customs, datapointsVisitorsReducer: datapoints, comparisonVisitorsReducer: comparison } = pipelineParameter || {};
    return { builder, comparison, custom: getMethod("highchartsOneMeasure", customs), nodes, sort: getMethod("sortByDatapoint", datapoints) };
};
const updateNodesVisitors = (action, nodes) => {
    for (const node of nodes.filter((n) => n.method !== "addFormattedValueVisitor")) {
        node.arguments = [action.payload.id];
    }
    const [shortFormatValue, fullFormatValue] = nodes.filter((n) => n.method === "addFormattedValueVisitor") || [];
    if (shortFormatValue) {
        shortFormatValue.arguments = [`S-${action.payload.id}`, action.payload.id, "short", "bar"];
    }
    if (fullFormatValue) {
        fullFormatValue.arguments = [`F-${action.payload.id}`, action.payload.id, "full", "bar"];
    }
};
const getFooter = (action, original) => {
    const format = Object.entries(formatToColumnTypes).find((e) => e[1] === action.payload.type)?.[0];
    if (format === CommmonFormatEnum.amount) {
        return { ...original, showCurrency: true };
    }
    else if (original) {
        delete original.showCurrency;
    }
    return original;
};
const enableVariationInPipeline = (pipelineParameter, percentOfTotal) => {
    const { builder, nodes, custom } = getReducers(pipelineParameter);
    if (builder?.measures && builder.measures.includes(percentOfTotal || "")) {
        builder.measures.splice(builder.measures.indexOf(percentOfTotal || ""), 1);
    }
    if (nodes) {
        nodes.splice(nodes.findIndex((n) => n.method === "addFormattedValueVisitor" && n.arguments?.includes(percentOfTotal)), 1);
        nodes.splice(nodes.findIndex((n) => n.method === "addTotalValueVisitor"), 1);
    }
    if (custom?.arguments?.length) {
        delete custom.arguments[0].inPercent;
    }
};
const disableVariationInPipeline = (action, pipelineParameter, percentOfTotal) => {
    const { builder, nodes, custom } = getReducers(pipelineParameter);
    const formattedName = `P-${action.payload.id}`;
    if (builder?.measures && !builder.measures.includes(percentOfTotal || "")) {
        builder.measures.push(percentOfTotal || "");
    }
    if (nodes) {
        const percentFormatter = nodes.find((n) => n.method === "addFormattedValueVisitor" && n.arguments?.includes("percent"));
        if (percentFormatter) {
            percentFormatter.arguments = [formattedName, percentOfTotal, "percent", "bar"];
        }
        else {
            nodes.push({ arguments: [formattedName, percentOfTotal, "percent", "bar"], method: "addFormattedValueVisitor" });
        }
        if (!nodes.find((n) => n.method === "addTotalValueVisitor")) {
            nodes.push({ method: "addTotalValueVisitor" });
        }
    }
    if (custom) {
        custom.arguments = [{ ...custom.arguments?.[0], inPercent: formattedName }];
    }
};
const updatePipelineParmeter = (action, pipelineParameter, mode, withLabel) => {
    const { builder, sort, nodes, custom } = getReducers(pipelineParameter);
    if (builder?.measures) {
        if (!builder.measures.includes(action.payload.id)) {
            builder.measures.push(action.payload.id);
        }
        if (mode === WidgetMode.Comparison && !builder.measures.includes(defaultComparisonMeasureName)) {
            builder.measures.push(defaultComparisonMeasureName);
        }
        else if (mode !== WidgetMode.Comparison && builder.measures.includes(defaultComparisonMeasureName)) {
            builder.measures.splice(builder.measures?.indexOf(defaultComparisonMeasureName), 1);
        }
    }
    if (sort) {
        sort.arguments = [action.payload.id, "Asc"];
    }
    nodes && updateNodesVisitors(action, nodes);
    const defaultLabel = withLabel ? { defaultLabel: action.payload.name } : {};
    if (custom) {
        custom.arguments = [
            { ...custom.arguments?.[0],
                ...defaultLabel,
                inFullFormat: `F-${action.payload.id}`,
                inShortFormat: `S-${action.payload.id}`,
                measureName: action.payload.id }
        ];
    }
};
const extract = (arr, options, kind, id) => {
    const option = options?.find((o) => o.datapointKind === kind);
    const index = (arr || []).findIndex((d) => d.name === (id ? id : option?.id));
    return { datapoint: index >= 0 ? arr?.splice(index, 1)?.[0] : undefined, name: option?.name };
};
const getDefaultPipelineParameter = () => (WorkShopInitialStateByType[WidgetType.Bar]("")?.componentProps || {}).pipelineParameter || {};
const populateCustomVisitorReducer = (componentProps) => {
    const custom = getMethod("highchartsOneMeasure", componentProps.pipelineParameter?.customVisitorsReducer);
    if (custom && custom.arguments?.length) {
        const [arg] = custom.arguments;
        custom.arguments[0] = { inFullFormat: arg.inFullFormat, inPercent: arg.inPercent, inShortFormat: arg.inShortFormat, measureName: arg.measureName };
    }
    return custom;
};
const populateComparisionVisitorReducer = (pipelinerParameter, nameMeasure) => {
    if (pipelinerParameter) {
        if (nameMeasure) {
            const compare = getMethod("groupHighchartsOneMeasure", getDefaultPipelineParameter().comparisonVisitorsReducer);
            if (compare && compare.arguments?.length) {
                pipelinerParameter.comparisonVisitorsReducer = [{ ...compare, arguments: [...compare.arguments, nameMeasure] }];
            }
        }
        else {
            const compare = getMethod("groupHighchartsOneMeasure", pipelinerParameter.comparisonVisitorsReducer);
            compare?.arguments?.splice(1);
        }
    }
};
export const addOrUpdateMeasure = (state, action, componentProps) => {
    const rawName = getPercentOfTotalDatapointName(action.payload.id);
    const shouldUsePercentOfTotal = supportsPercent(action.payload) && !isRawPercentMeasure(action.payload);
    if (action.payload.variation) {
        if (componentProps.userSettings) {
            componentProps.userSettings.displayValueType = DisplayValueType.Numeral;
        }
        shouldUsePercentOfTotal && enableVariationInPipeline(componentProps.pipelineParameter, rawName);
        shouldUsePercentOfTotal && removeDatapointRequest(state, rawName);
    }
    else {
        if (componentProps.userSettings) {
            componentProps.userSettings.chartTypeAvailable = "SingleDimension";
        }
        shouldUsePercentOfTotal && updateOrAddDatapointRequest(state, { ...action.payload, id: rawName, percent: true });
        shouldUsePercentOfTotal && disableVariationInPipeline(action, componentProps.pipelineParameter, rawName);
    }
    componentProps.colorSet = action.payload.variation ? "dualDefault" : "default";
    updatePipelineParmeter(action, componentProps.pipelineParameter, componentProps.mode, true);
    componentProps.footer = getFooter(action, componentProps.footer);
};
const applyPercentOfTotalPipeline = (action, pp, rawName, dp) => {
    if (action.payload.variation) {
        enableVariationInPipeline(pp, rawName);
    }
    else {
        disableVariationInPipeline(action, pp, rawName);
        dp[0].measures.push(getDatapointRequestElementFromColumnOptionState({ ...action.payload, id: rawName, percent: true }));
    }
};
export const addOrUpdateMeasureToDataSelectProps = (state, action, componentProps) => {
    const [measures] = componentProps.dataSelectProps, footer = getFooter(action), measure = getDatapointRequestElementFromColumnOptionState(action.payload), rawName = getPercentOfTotalDatapointName(action.payload.id);
    const datapointParams = [{ dimensions: [], measures: [measure] }], pipelineParameter = getDefaultPipelineParameter();
    const shouldUsePercentOfTotal = supportsPercent(action.payload) && !isRawPercentMeasure(action.payload);
    measures.selectValues[action.payload.id] = { datapointParams, displayName: action.payload.name || "", footer, pipelineParameter };
    shouldUsePercentOfTotal && applyPercentOfTotalPipeline(action, pipelineParameter, rawName, datapointParams);
    updatePipelineParmeter(action, pipelineParameter, componentProps.mode);
    if (!shouldUsePercentOfTotal) {
        pipelineParameter.nodesVisitorsReducer = pipelineParameter.nodesVisitorsReducer?.filter((n) => n.method !== "addTotalPercentageToLeafVisitor");
    }
    if (componentProps.userSettings) {
        if (state.editor.settings?.data?.columns?.options?.some((o) => o.variation)) {
            delete componentProps.userSettings.chartTypeAvailable;
        }
        else {
            componentProps.userSettings.chartTypeAvailable = "SingleDimension";
        }
    }
};
export const addOrUpdateDimension = (state, action, componentProps) => {
    const { compositeObjectBuilder: builder, customVisitorsReducer: customs } = componentProps.pipelineParameter, custom = getMethod("highchartsOneMeasure", customs);
    const isIdNameCase = action.payload.datapoint && isDimensionName(action.payload.datapoint);
    let newId = "";
    if (isIdNameCase) {
        newId = getIdDimensionDatapointName(action.payload.id);
        const IdDatapointInsteadOfName = action.payload.datapoint === undefined ? action.payload.datapoint : convertDimensionFromNameToId(action.payload.datapoint);
        removeManyDatapointRequests(state, [action.payload.id]);
        updateOrAddDatapointRequest(state, { ...action.payload, datapoint: IdDatapointInsteadOfName, id: newId });
        updateOrAddDatapointRequest(state, { ...action.payload, datapointKind: DatapointKind.Measure });
    }
    if (builder?.dimensions && !builder?.dimensions.includes(action.payload.id)) {
        builder.dimensions.push(action.payload.id);
    }
    if (custom) {
        custom.arguments = [{ ...custom.arguments?.[0], dimensionLabel: action.payload.name }];
    }
    populateComparisionVisitorReducer(componentProps.pipelineParameter, isIdNameCase ? action.payload.id : undefined);
};
export const addOrUpdateDimensionToDataSelectProps = (state, action, componentProps) => {
    const [, dimensions] = componentProps.dataSelectProps;
    const isIdNameCase = action.payload.datapoint && isDimensionName(action.payload.datapoint);
    let dimension = getDatapointRequestElementFromColumnOptionState(action.payload), measures = [], newId = action.payload.id;
    const pipelineParameter = { compositeObjectBuilder: { dimensions: [action.payload.id], measures: [] } };
    if (isIdNameCase) {
        newId = getIdDimensionDatapointName(action.payload.id);
        const idDatapointInsteadOfName = action.payload.datapoint === undefined ? action.payload.datapoint : convertDimensionFromNameToId(action.payload.datapoint);
        const measure = getDatapointRequestElementFromColumnOptionState({ ...action.payload, datapointKind: DatapointKind.Measure });
        dimension = getDatapointRequestElementFromColumnOptionState({ ...action.payload, datapoint: idDatapointInsteadOfName, id: newId });
        measures = [measure];
        populateComparisionVisitorReducer(pipelineParameter, action.payload.id);
    }
    dimensions.selectValues[newId] = { datapointParams: [{ dimensions: [dimension], measures }],
        displayName: action.payload.name || "",
        pipelineParameter };
};
export const switchToDataSelectPropsMode = (componentProps, options) => {
    if (componentProps.dataSelectProps?.length) {
        return;
    }
    const { datapoint: dimension, name: dimensionName } = extract(componentProps.datapointParams?.[0]?.dimensions, options, DatapointKind.Dimension), { datapoint: measure, name: measureName } = extract(componentProps.datapointParams?.[0]?.measures, options, DatapointKind.Measure), { datapoint: percentMeasure } = extract(componentProps.datapointParams?.[0]?.measures, options, DatapointKind.Measure, getPercentOfTotalDatapointName(measure?.name)), { datapoint: nameMeasure } = extract(componentProps.datapointParams?.[0]?.measures, options, DatapointKind.Dimension), { datapoint: idDimension, name: idDimensionName } = extract(componentProps.datapointParams?.[0]?.dimensions, options, DatapointKind.Dimension, getIdDimensionDatapointName(nameMeasure?.name));
    let dimensionValues = {};
    const measureValues = measure?.name
        ? { [measure.name]: {
                datapointParams: [{ dimensions: [], measures: percentMeasure ? [measure, percentMeasure] : [measure] }],
                defaultValue: true,
                displayName: measureName,
                footer: { ...componentProps.footer },
                pipelineParameter: { compositeObjectBuilder: { ...componentProps.pipelineParameter?.compositeObjectBuilder,
                        dimensions: componentProps.pipelineParameter?.compositeObjectBuilder?.dimensions?.filter((d) => d !== dimension?.name) },
                    customVisitorsReducer: [populateCustomVisitorReducer(componentProps)],
                    datapointsVisitorsReducer: componentProps.pipelineParameter?.datapointsVisitorsReducer,
                    nodesVisitorsReducer: componentProps.pipelineParameter?.nodesVisitorsReducer }
            } }
        : {};
    if (dimension || idDimension) {
        const selectedDimension = dimension || idDimension;
        if (selectedDimension?.name) {
            const config = { datapointParams: [{ dimensions: [selectedDimension], measures: nameMeasure ? [nameMeasure] : [] }],
                defaultValue: true,
                displayName: dimensionName || idDimensionName,
                pipelineParameter: { compositeObjectBuilder: { dimensions: [nameMeasure?.name ?? selectedDimension.name], measures: [] } } };
            populateComparisionVisitorReducer(config.pipelineParameter, nameMeasure?.name);
            dimensionValues = { [selectedDimension.name]: config };
        }
    }
    componentProps.dataSelectProps = [{ order: 0, selectValues: measureValues }, { label: language.en.common.by, order: 1, selectValues: dimensionValues }];
    componentProps.pipelineParameter = { comparisonVisitorsReducer: componentProps.pipelineParameter?.comparisonVisitorsReducer };
    delete componentProps.footer?.showCurrency;
};
export const switchToSimpleMode = (componentProps) => {
    if (!componentProps.dataSelectProps?.length) {
        return;
    }
    const [measures, dimensions] = componentProps.dataSelectProps;
    const [dimension] = Object.values(dimensions.selectValues), [measure] = Object.values(measures.selectValues), [request] = componentProps.datapointParams || [];
    componentProps.datapointParams = [
        {
            dimensions: [...dimension?.datapointParams?.[0]?.dimensions || [], ...request?.dimensions || []],
            measures: [...measure?.datapointParams?.[0]?.measures || [], ...request?.measures || [], ...dimension?.datapointParams?.[0]?.measures || []]
        }
    ];
    componentProps.pipelineParameter = { ...componentProps.pipelineParameter,
        ...measure?.pipelineParameter,
        comparisonVisitorsReducer: dimension?.pipelineParameter?.comparisonVisitorsReducer ?? componentProps.pipelineParameter?.comparisonVisitorsReducer,
        compositeObjectBuilder: {
            dimensions: [...measure?.pipelineParameter?.compositeObjectBuilder?.dimensions || [], ...dimension?.pipelineParameter?.compositeObjectBuilder?.dimensions || []],
            measures: measure?.pipelineParameter?.compositeObjectBuilder?.measures || []
        } };
    const custom = getMethod("highchartsOneMeasure", componentProps.pipelineParameter?.customVisitorsReducer);
    if (custom && custom.arguments) {
        custom.arguments = [{ ...custom.arguments?.[0], defaultLabel: measure?.displayName, dimensionLabel: dimension?.displayName }];
    }
    componentProps.dataSelectProps = [];
    componentProps.footer = { ...componentProps.footer, ...measure?.footer };
};
export const resetComponentProps = (state, options, componentProps) => {
    const [remaining] = options;
    componentProps.pipelineParameter = WorkShopInitialStateByType[WidgetType.Bar]("")?.componentProps?.pipelineParameter;
    if (remaining) {
        if (remaining.datapointKind === DatapointKind.Dimension) {
            addOrUpdateDimension(state, { payload: remaining, type: "" }, componentProps);
        }
        else if (remaining.datapointKind === DatapointKind.Measure) {
            addOrUpdateMeasure(state, { payload: remaining, type: "" }, componentProps);
        }
    }
};
